<template>
    <div class="small text-center">
        {{$filters.getByte(curr)}}
        /
        {{$filters.getByte(max)}}
        <div class="progress" style="height: 2px;">
            <div class="progress-bar" role="progressbar"
                :class="{'bg-danger': storage >= 95}"
                :style="{width: storage + '%'}"
                aria-valuenow="storage" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        curr: {
            default: 0
        },
        max: {
            default: 5242880
        }
    },
    computed: {
        storage() {
            if (!this.curr) return 0;
            let percentage = this.curr / this.max * 100;
            if (percentage > 100) percentage = 100;
            return percentage;
        },
    },
}
</script>